<div *ngIf="fields" class="generic-event-activity-settings-settings aza-pa-flex-column">
    <mat-accordion [multi]="true">
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span translate>ACTIVITY_VISIBILITY</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="aza-pa-flex-column">
                <div class="aza-pa-flex-row">
                    <azavista-input-field *ngIf="fields.dependency.value" [field]="fields.dependency.field"
                        [value]="fields.dependency.value" [editMode]="true" [canEdit]="true"
                        label="{{'DEPENDENCY' | translate}}" (valueChanged)="onDependencyValueChanged($event)">
                    </azavista-input-field>
                    <azavista-button (click)="showDependencies()">
                        <span translate>CREATE_NEW_DEPENDENCY</span>
                    </azavista-button>
                </div>
                <azavista-input-field [field]="fields.display" [value]="eventActivitySettings.display"
                    [options]="fields.displayOptions" [editMode]="true" [canEdit]="true"
                    label="{{'DISPLAY' | translate}}" (valueChanged)="onDisplayValueChanged($event)">
                </azavista-input-field>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span translate>ACTIVITY_REGISTRATION</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="aza-pa-flex-column">
                <mat-slide-toggle [checked]="eventActivitySettings.registration"
                    (change)="onRegistrationSlideValueChanged($event)" color="primary">
                    <span translate>REGISTRATION_REQUIRED_FOR_THIS_ACTIVITY</span>
                </mat-slide-toggle>
                <!-- <azavista-input-field [field]="fields.registration" [value]="eventActivitySettings.registration" [editMode]="true"
        [canEdit]="true" label="{{'REGISTRATION_REQUIRED_FOR_THIS_ACTIVITY' | translate}}" [showLabelForBooleans]="true"
        (valueChanged)="onRegistrationValueChanged($event)">
    </azavista-input-field> -->
                <ng-container *ngIf="eventActivitySettings.registration">
                    <mat-slide-toggle [checked]="eventActivitySettings.approval"
                        (change)="setSetting({approval: $event.checked})" color="primary">
                        <span>{{translations.APPROVAL_REQUIRED | translate}}</span>
                    </mat-slide-toggle>
                    <mat-slide-toggle [checked]="eventActivitySettings.overlap_registration"
                        (change)="setSetting({overlap_registration: $event.checked})" color="primary">
                        <span>{{translations.OVERLAP_REGISTRATION_LABEL | translate}}</span>
                    </mat-slide-toggle>
                    <azavista-input-field [field]="fields.capacity" [value]="eventActivitySettings.capacity"
                        [editMode]="true" [canEdit]="true" label="{{'CAPACITY' | translate}}"
                        (valueChanged)="onCapacityValueChanged($event)">
                    </azavista-input-field>
                </ng-container>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel
            *ngIf="eventActivitySettings.registration && eventActivitySettings.capacity !== null && eventActivitySettings.capacity !== undefined"
            [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span translate>ACTIVITY_WAITING_LIST</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="aza-pa-flex-column">
                <mat-slide-toggle [checked]="eventActivitySettings.waitinglist"
                    (change)="onWaitingListSlideValueChanged($event)" color="primary">
                    <span translate>USE_WAITING_LIST</span>
                </mat-slide-toggle>
                <!-- <azavista-input-field [field]="fields.waitinglist" [value]="eventActivitySettings.waitinglist" [editMode]="true"
    [canEdit]="true" label="{{'USE_WAITING_LIST' | translate}}" [showLabelForBooleans]="true"
    (valueChanged)="onWaitingListValueChanged($event)">
</azavista-input-field> -->
                <ng-container *ngIf="eventActivitySettings.waitinglist">
                    <azavista-input-field [field]="fields.promotionEmail.field" [value]="fields.promotionEmail.value"
                        [editMode]="true" [canEdit]="true" label="{{'PROMOTION_EMAIL' | translate}}"
                        (valueChanged)="onPromotionEmailValueChanged($event)">
                    </azavista-input-field>
                </ng-container>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
